import { jsx as _jsx } from "react/jsx-runtime";
import EditUserForm from '../features/users/components/EditUserForm';

const EditUser = () => {
  return /*#__PURE__*/_jsx("article", {
    "data-test-id": "edit-profile-page",
    children: /*#__PURE__*/_jsx(EditUserForm, {})
  });
};

export default EditUser;